export enum InquiryCustomCakeSize {
	Portions12 = "Portions12",
	Portions18 = "Portions18",
	Portions25 = "Portions25",
	Custom = "Custom",
}
